import { render, staticRenderFns } from "./PrivateView.vue?vue&type=template&id=235ef496"
import script from "./PrivateView.vue?vue&type=script&lang=js"
export * from "./PrivateView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports